<template>
  <div id="SecondsUntilExpire" :style="{ width: activeWidth }" :class="{ loaderOpacity: showLoader }">
    <loader v-if="showLoader"></loader>
    <vue-progress-bar class="progress_bar_header"></vue-progress-bar>
    <router-view></router-view>
    <teamMembers></teamMembers>
    <videoChat></videoChat>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { browserClassNames } from "@/utils/browserInfo";
import teamMembers from "../tele-health-sp/team-members";
import videoChat from "../tele-health-sp/video-chat";
import loader from "../common/loader";
import eventBus from "@/eventBus";
export default {
  name: "App",
  data() {
    return {
      activeWidth: "auto"
    };
  },
  components: { teamMembers, videoChat, loader },
  computed: mapGetters(["user", "token", "showLoader"]),
  watch: {
    user() {
      this.setAccess();
    }
  },
  created() {
    this.setAccess();
  },
  methods: {
    ...mapActions(["clientIdSuccess", "clientName"]),
    setAccess() {
      if (this.token) {
        this.access = ["public", "auth", this.user.userRole];
      } else {
        this.access = ["public"];
      }
    }
  },
  mounted() {
    document.body.className += ` ${browserClassNames}`;
    const self = this;
    //Video Call Started resize the width of main div
    this.$root.$on("videoCallSessionConnected", () => {
      self.$store.dispatch("setVideoCallStatusAction", true);
      eventBus.$emit("setTeleHelathCallStatus", true);
      this.activeWidth = "74%";
    });

    //Video Call ended revert back the width
    this.$root.$on("videoCallEnded", () => {
      this.$store.dispatch("setVideoCallStatusAction", false);
      eventBus.$emit("setTeleHelathCallStatus", false);
      this.activeWidth = "100%";
    });
    // hide the side panel if screen sharing is enabled
    this.$root.$on("screenSharingStarted", () => {
      this.activeWidth = "100%";
    });
    this.$root.$on("screenSharingEnded", () => {
      this.activeWidth = "74%";
    });
    this.$root.$on("switchScreen", value => {
      if (value.type == "thPanel") {
        this.activeWidth = "74%";
      } else {
        this.activeWidth = "100%";
      }
    });
    this.$root.$on("playBackVideoEnded", () => {
      this.activeWidth = "100%";
    });
    this.$root.$on("fullScreen", value => {
      if (value) {
        this.activeWidth = "100%";
      } else {
        this.activeWidth = "74%";
      }
    });
  },
  beforeCreate() {
    // -----------------------------------
    // |      Zendesk Remote Login       |
    // -----------------------------------
    const params = new URLSearchParams(window.location.search);
    if (params.has("return_to") && process.env.VUE_ZENDESK_REMOTE_LOGIN_URL) {
      window.location.replace(process.env.VUE_ZENDESK_REMOTE_LOGIN_URL);
    }
  }
};
</script>
<style scoped lang="scss">
#SecondsUntilExpire {
  max-height: 0px;
}
.loaderOpacity {
  opacity: 0.9;
}
</style>
